import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GlobalService } from './global-service.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {
    constructor(private router: Router, private globserv: GlobalService) { }
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;
        return this.userIsLoggedIn(url);
    }

    private userIsLoggedIn(url: string): boolean {
		
		console.log("url=" +url +" / LoginStatus=" + this.globserv.Login.LoginStatus) ;
		
		if(url=="/login" && this.globserv.Login.LoginStatus )
		{
			//this.router.navigate(['/pasura']);
		}		
		
		if(url=="/logout")
		{
			this.globserv.setLogOut();
		}
		
		/*
		if(url=="/benutzer" && !this.globserv.Login.Admin)
		{
			return false;
		}
		*/
		
		if (this.globserv.Login.LoginStatus)
		{
			return true;
		}
		
		
		
		this.router.navigate(['/login']);
    }
}